export default __webpack_public_path__ + "static/media/vb_9.630aae52.jpg";